var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 294875"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13 25C19.6274 25 25 19.6274 25 13C25 6.37258 19.6274 1 13 1C6.37258 1 1 6.37258 1 13C1 19.6274 6.37258 25 13 25Z",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 6",
    d: "M18.3328 12.5783L14.8247 9.0873C14.6983 8.96254 14.5277 8.89295 14.3501 8.89374C14.1725 8.89454 14.0025 8.96567 13.8772 9.09156C13.7519 9.21745 13.6817 9.38784 13.6818 9.56543C13.6819 9.74302 13.7523 9.91333 13.8777 10.0391L16.2332 12.3828H7.91545C7.73741 12.3828 7.56666 12.4536 7.44076 12.5795C7.31487 12.7054 7.24414 12.8761 7.24414 13.0542C7.24414 13.2322 7.31487 13.403 7.44076 13.5289C7.56666 13.6548 7.73741 13.7255 7.91545 13.7255H16.2325L13.8771 16.0693C13.7517 16.195 13.6812 16.3653 13.6811 16.5429C13.681 16.7205 13.7513 16.8909 13.8765 17.0168C14.0018 17.1427 14.1718 17.2138 14.3494 17.2146C14.527 17.2154 14.6976 17.1458 14.824 17.021L18.3321 13.53C18.3948 13.4677 18.4445 13.3935 18.4785 13.3119C18.5124 13.2303 18.53 13.1427 18.53 13.0543C18.5301 12.9659 18.5127 12.8783 18.4789 12.7966C18.445 12.715 18.3954 12.6407 18.3328 12.5783Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStart);
export default __webpack_public_path__ + "static/media/start.0ffb1539a076c35eceef31d298fa4105.svg";
export { ForwardRef as ReactComponent };